import PropTypes from 'prop-types';

// material-ui
import { Divider, List, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import { useAdminRole } from 'hooks/master/roles.hooks';
import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
	const theme = useTheme();
	const { data } = useAdminRole();
	const roles = JSON.parse(localStorage.getItem('user')).roles;

	let updatedItem = item.children;

	if (data && data.isAdmin === false) {
		if (item.title === 'Masters') updatedItem = item.children.filter(master => master.title !== 'Other');
		if (item.title === 'Organization') updatedItem = item.children.filter(organization => organization.title !== 'Audit Logs');
	}
	if(!roles.some(role => role.role_description === 'DEVELOPER')) {
		const optionsToExclude = ['Workflows', 'Rule Groups', 'Partner Rule Groups'];
		if (item.title === 'Organization') 
			updatedItem = item.children.filter(organization => !optionsToExclude.includes(organization.title));
	}

	const items = updatedItem?.map(menu => {
		switch (menu.type) {
			case 'collapse':
				return <NavCollapse key={menu.id} menu={menu} level={1} />;
			case 'item':
				return <NavItem key={menu.id} item={menu} level={1} />;
			default:
				return (
					<Typography key={menu.id} variant="h6" color="error" align="center">
						Menu Items Error
					</Typography>
				);
		}
	});

	return (
		<>
			<List
				subheader={
					item.title && (
						<Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
							{item.title}
							{item.caption && (
								<Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
									{item.caption}
								</Typography>
							)}
						</Typography>
					)
				}
			>
				{items}
			</List>

			{/* group divider */}
			<Divider sx={{ mt: 0.25, mb: 1.25 }} />
		</>
	);
};

NavGroup.propTypes = {
	item: PropTypes.object,
};

export default NavGroup;
